module.exports = __webpack_public_path__ + "static/nav-contact-5-f971ae4b078035626dbf2c345e4b379f.jpg";